import {
  DYNAMIC_PROCESS_APPROVER_NOTIFICATION,
  SaveNotificationTemplateForm,
} from "@/modules/admin-panel/notification-templates/features/save-notification-template";
import { DYNAMIC_PROCESS_FORM } from "../dynamic-process-form-provider/forms-enum";
import { Model } from "../../model/types";
import { NotificationForm } from "@/modules/admin-panel/notification-templates/shared/notification-form";

export function ApproverTemplateForm({ model }: { model: Model }) {
  return (
    <SaveNotificationTemplateForm
      name={DYNAMIC_PROCESS_FORM.APPROVER}
      code={DYNAMIC_PROCESS_APPROVER_NOTIFICATION}
      partOf
      initialValues={{
        ...NotificationForm.transformers.notificationTemplateValueDtoToNotificationTemplateInput(
          model?.approverNotificationTemplate?.value,
        ),
      }}
    />
  );
}
